import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {AuditTriggerLogs} from '@drl/shared/models/audit-trigger-logs.model';
import * as moment from 'moment';
import {AlertStatus, alertLogStatusMap} from '@drl/shared/utility/alerts.enum';
import {Alerts} from '@drl/shared/models/alerts.model';
import {timeFormat} from '@drl/shared/utility/time-format';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';

@Injectable(
  {
    providedIn:'root'
  }
)
export class AlertAuditLogAdapter implements IAdapter<AuditTriggerLogs> {
  constructor(protected readonly translateSvc: IpsTranslateService) {}
  adaptToModel(resp: AuditTriggerLogs): AuditTriggerLogs {
    const alertLogStatus = alertLogStatusMap(this.translateSvc.translate);
    const alertAuditLog: AuditTriggerLogs = {...resp};
    if (resp.operationName === alertLogStatus.INSERT) {
      alertAuditLog.operationName = alertLogStatus.AlertCreated;
    } else if (resp.operationName === alertLogStatus.UPDATE) {
      if (
        (resp.before as Alerts).status === AlertStatus.Active &&
        (resp.after as Alerts).status === AlertStatus.Resolved
      ) {
        alertAuditLog.operationName = alertLogStatus.AlertResolved;
      } else {
        alertAuditLog.operationName = alertLogStatus.AsigneeUpdated;
      }
    } else {
      // Do nothing
    }

    if (resp.operationTime) {
      alertAuditLog.dateString = new Date(
        resp.operationTime,
      ).toLocaleDateString();

      alertAuditLog.timeOfCreation = moment(resp.operationTime).format(
        timeFormat,
      );
    }

    return alertAuditLog;
  }
  // sonarignore:start
  adaptFromModel(data: AuditTriggerLogs): any {
    return data;
  }
  // sonarignore:end
}
